(ns machtfit.startpage.subs
  (:require [cljs-time.core :as time]
            [clojure.set :as set]
            [clojure.string :as str]
            [goog.string :as gstring]
            [goog.string.format]
            [machtfit.datetime :as datetime]
            [machtfit.feature :as feature]
            [machtfit.repository.health-profile :as health-profile]
            [machtfit.repository.offer-layers :as offer-layers]
            [machtfit.repository.products :as products]
            [machtfit.repository.search-facets :as search-facets]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.startpage.filter :as filter]
            [machtfit.startpage.search :as search]
            [machtfit.startpage.statics :as statics]
            [medley.core :refer [interleave-all]]
            [re-frame.core :as rf])
  (:require-macros [reagent.ratom :refer [reaction]]))

(comment
  ;; db structure
  {:login-error nil,
   :qrcode-svg nil,
   :submitted-invoice nil,
   :requirements {:min-length nil, :count-digits-from nil},
   :stepchall {:stages nil,
               :challenge-start nil,
               :participants nil,
               :team-building-start-date nil,
               :on-top-of-start-page? nil,
               :goal nil,
               :recording-end nil,
               :route {:background-image {:url nil,
                                          :height nil,
                                          :width nil}},
               :participant {:step-counts {:daily nil, :total nil},
                             :deactivated-at nil,
                             :deactivated-at-date nil,
                             :nickname nil,
                             :rank nil,
                             :recent-activities nil},
               :teams nil,
               :show-participant-leaderboard? nil,
               :theme {:path nil, :team-palette nil},
               :challenge-end-date nil,
               :product-url nil,
               :total {:participants nil, :steps nil},
               :stop-aggregation-after-goal-reached? nil,
               :show-nutrition-challenge-faq? nil,
               :team {:id nil,
                      :name nil,
                      :color nil,
                      :members nil,
                      :member-count nil,
                      :access-code nil,
                      :rank nil,
                      :step-counts {:total nil, :daily nil}},
               :id nil,
               :challenge-end nil,
               :challenge-start-date nil,
               :team-building-start nil,
               :feedback-url nil,
               :activities nil,
               :loaded-participants nil,
               :activity-units nil,
               :show-team-privacy-box? nil,
               :names {:challenge-name nil},
               :team-building-end nil,
               :team-building-end-date nil},
   :errors nil,
   :email nil,
   :is-favorite nil,
   :urls {:catalogue:company nil,
          :terms nil,
          :customer:register-on-subdomain nil,
          :password-reset nil,
          :set_language nil,
          :privacy-policy nil,
          :magazin:rezepte nil,
          :content:index-magazin nil,
          :content:index-bgm-info nil,
          :contact nil,
          :faq nil,
          :customer:register nil,
          :dashboard:index nil,
          :customer:logout nil,
          :customer:profile-view nil,
          :customer:profile-update nil},
   :password-error? nil,
   :io {:routes nil,
        :test-data {:start nil, :end nil},
        :save-url nil,
        :supplier-list-certificates-url nil,
        :show-test-data-form? nil,
        :test-data-aggregate-url nil,
        :product-choices-url nil,
        :supplier-lookup-url nil,
        :csrf-token nil,
        :upload-certificate-url nil,
        :test-data-generate-activity-url nil},
   :health-expense {:amount nil,
                    :submitter-comments nil,
                    :invoice-period-end nil,
                    :activity nil,
                    :status nil,
                    :id nil,
                    :files nil,
                    :extra-field nil,
                    :invoice-period-start nil},
   :user-balance nil,
   :suppliers nil,
   :partner {:name nil},
   :password nil,
   :favorites nil,
   :images nil,
   :articles nil,
   :subdomain-info {:logo nil,
                    :base-color nil,
                    :base-color-light nil,
                    :light-base-color? nil,
                    :base-url nil},
   :reviewer-note nil,
   :partner-product-categories nil,
   :in-progress? nil,
   :subdomain nil,
   :user-note nil,
   :init-data nil,
   :certificates nil,
   :preamble nil,
   :product {:who {:contact-salutation nil,
                   :contact-first-name nil,
                   :contact-last-name nil,
                   :contact-email nil,
                   :supplier-name nil,
                   :executing-supplier nil,
                   :certificate-id nil},
             :where {:location-type nil,
                     :usage-description nil,
                     :is-stream? nil,
                     :is-app? nil,
                     :is-open-despite-corona? nil,
                     :address {:name nil,
                               :street nil,
                               :extra nil,
                               :postcode nil,
                               :city nil,
                               :country nil}},
             :when {:weekdays nil,
                    :slots nil,
                    :has-schedule? nil,
                    :sessions-per-signup nil,
                    :offer-list-deadline nil,
                    :registration-deadline-relative nil,
                    :cohesion nil,
                    :schedules nil,
                    :unit-duration nil},
             :state nil,
             :title nil,
             :id nil,
             :for-whom {:min-participants nil,
                        :max-participants nil,
                        :audience-gender nil,
                        :audience-age nil,
                        :allowed-employees nil,
                        :area-independent-access false},
             :how {:extra-info-fields nil,
                   :access-codes nil,
                   :require-user-info nil,
                   :participant-instructions nil,
                   :user-info-explanation-text nil,
                   :needs-access-code? nil,
                   :registration-url nil,
                   :registration-type nil,
                   :access-codes-warning-threshold nil,
                   :registration-needed? nil},
             :how-much {:amount nil,
                        :suggested-retail-price nil,
                        :validity-period nil,
                        :number-of-appointments nil,
                        :commission nil,
                        :vat nil,
                        :subsidies nil,
                        :price-given? nil,
                        :max-bookings nil},
             :what {:description nil,
                    :category nil,
                    :article-number nil,
                    :labels nil,
                    :promoted? nil,
                    :source-type nil,
                    :p20-certified? nil,
                    :image-id nil,
                    :title nil,
                    :source-url nil,
                    :attachments nil,
                    :sorting-number nil,
                    :website nil,
                    :source-id nil,
                    :bookable? nil}},
   :validation-results {:requirements nil},
   :privacy-policy nil,
   :filter {:labels nil,
            :subsidy nil,
            :age nil,
            :apps? nil,
            :favorites nil,
            :free-of-charge? nil,
            :no-schedule nil,
            :times nil,
            :estg3no34-subsidizable? nil,
            :days nil,
            :streams nil,
            :product-types nil,
            :online nil,
            :categories nil,
            :keyword nil,
            :mf-offer nil,
            :promotions nil,
            :area nil,
            :price-min nil,
            :price-max nil,
            :sort-by nil,
            :gender nil,
            :distance nil},
   :payment-result nil,
   :categories nil,
   :is-app? nil,
   :app-version nil,
   :labels-with-groups nil,
   :iban-required? nil,
   :health-expenses-without-budget-usage? nil,
   :challenge {:active? nil,
               :challenge-start nil,
               :config {:goal nil, :stages nil, :names nil},
               :name nil,
               :on-top-of-start-page? nil,
               :route {:background-image {:url nil}},
               :theme {:path nil},
               :product nil,
               :challenge-end nil,
               :team-building-start nil,
               :feedback-url nil},
   :ui {:save-inhibitors nil,
        :home-card-animating? nil,
        :supplier {:commission-plan nil, :commission-rate nil},
        :stepchall {:leaderboard {:scope nil,
                                  :teams {:page nil},
                                  :participants {:page nil}},
                    :link-copy-result nil,
                    :send-message {:type nil,
                                   :receiver-participant-id nil,
                                   :receiver-name nil,
                                   :message nil,
                                   :message-sent? nil,
                                   :error-message nil},
                    :team-members-id nil,
                    :search nil,
                    :flag-onboarding-dismissed? nil,
                    :activity nil,
                    :team-form {:has-access-code? nil,
                                :team-name nil,
                                :access-code nil},
                    :open-faq-blocks nil,
                    :flag-spectator-alert-dismissed? nil,
                    :confirm-action nil,
                    :route-view-filter nil,
                    :flag-tracker-intro-dismissed? nil,
                    :route-edit {:enabled? nil,
                                 :key-modifiers nil,
                                 :selected-path-point {:index nil,
                                                       :dx nil,
                                                       :dy nil}},
                    :tooltip {:type nil, :id nil, :num-steps nil},
                    :activity-value nil},
        :add-image-image-url nil,
        :attachments-message nil,
        :selected-start nil,
        :show-products nil,
        :num-participants nil,
        :place-order-state nil,
        :selected-end nil,
        :partner nil,
        :page {:id nil,
               :subpage nil,
               :team-id nil,
               :activity nil,
               :context nil,
               :add-activity-request-in-progress? nil,
               :add-activity-request-in-progress-from-modal? nil,
               :error {:name nil}},
        :image-section-expanded {},
        :show-all-certificates? nil,
        :seen-sections nil,
        :add-image-url nil,
        :in-progress? nil,
        :changed-amount nil,
        :accept-privacy-policy nil,
        :certificate-info-message nil,
        :company-area-name nil,
        :editing {:recipient nil, :rule nil},
        :show-reject-modal? nil,
        :vat-options nil,
        :filter nil,
        :reviewer-comments nil,
        :keyword nil,
        :employee-rules {:condition-options {:occupation-groups nil,
                                             :places-of-business nil,
                                             :subsidiaries nil,
                                             :companies nil}},
        :selected-company nil,
        :visible-dropdown nil,
        :show-accept-modal? nil,
        :clearance-date nil,
        :access-codes-used nil,
        :filter-preset nil,
        :publish? nil,
        :error-message nil,
        :cancel-url nil,
        :image-library-active? nil,
        :appointments-product-id nil,
        :currently-editing-certificate {:id nil},
        :certificate-save-errors nil,
        :validated? nil,
        :upload {:attachments nil, :image nil, :certificate nil},
        :last-focused-config-section nil,
        :new-category nil,
        :navigation-popover-key nil
        :breadcrumbs {}},
   :language nil,
   :companies nil,
   :validation-state nil,
   :reject-email-text nil,
   :csrf-token nil,
   :token-sent? nil,
   :clock {:diff-to-server-time nil, :current-server-time nil},
   :options {:has-sorting-number? nil,
             :company-product? nil,
             :has-active-trainer? nil,
             :can-create-category? nil,
             :can-customize-registration? nil,
             :can-see-source-type? nil,
             :is-reselling-product? nil,
             :can-decide-commission? nil,
             :can-set-allowed-employees? nil,
             :can-decide-age? nil,
             :can-save-only? nil,
             :product-needs-verification? nil,
             :can-promote? nil,
             :partner-product? nil},
   :error? nil,
   :form_errors nil,
   :templates nil,
   :server-info {:reference-now nil,
                 :reference-today nil,
                 :reference-tomorrow-start nil},
   :feature-name nil,
   :user {:machtfit-area-only-online? nil,
          :labels nil,
          :last-name nil,
          :has-health-expense? nil,
          :show-logo-on-company-area-tile? nil,
          :has-company-area? nil,
          :roles nil,
          :customer-number nil,
          :show-bgm-info? nil,
          :first-name nil,
          :company-id nil,
          :home-location nil,
          :place-of-business-location nil,
          :has-cockpit-access? nil,
          :company-area-tile-image-url nil,
          :company-phrasing nil,
          :notifications nil,
          :survey nil,
          :balance nil,
          :has-machtfit-area? nil,
          :products-cache-key nil,
          :authenticated? nil,
          :full-name nil,
          :managed-employees nil,
          :is-employee? nil,
          :stepchall-tile {:name nil,
                           :image-url nil,
                           :image-description nil,
                           :on-top-of-start-page? nil}},
   :message nil,
   :login-url nil,
   :slider {:items nil, :position nil},
   :data {:budgets nil,
          :limeplan-percent nil,
          :timeplan-date nil,
          :products nil,
          :type nil,
          :recipients nil,
          :rules nil,
          :quantityplan-percent nil,
          :categories nil,
          :occupation-groups nil,
          :places-of-business nil,
          :subsidiaries nil,
          :quantityplan-count nil,
          :companies nil,
          :employee-counts nil,
          :condition-options {:occupation-groups nil,
                              :subsidiaries nil,
                              :places-of-business nil,
                              :companies nil}},
   :ui-state nil
   :open-user-dropdown? false}
;;
  )

(rf/reg-sub ::is-app?
  (fn [db _]
    (get db :is-app?)))

(rf/reg-sub ::app-version-2?
  :<- [:get [:app-version]]

  (fn [app-version _]
    (and app-version
         (str/starts-with? app-version "2."))))

(rf/reg-sub ::app-version-3?
  :<- [:get [:app-version]]

  (fn [app-version _]
    (and app-version
         (str/starts-with? app-version "3."))))

(rf/reg-sub ::django-url
  :<- [:get [:urls]]

  (fn [urls [_ url-key]]
    (url-key urls)))

(rf/reg-sub ::button-color
  :<- [:get [:subdomain-info :light-base-color?]]
  :<- [:get [:subdomain-info :base-color]]

  (fn [[light-base-color? base-color] _]
    {:background-color base-color :color (if light-base-color? "#393c40" "#ffffff")}))

                                        ; ARTICLES
(defn- tags->panel [tags]
  (distinct (flatten
             (for [tag tags]
               (case tag
                 "Bewegung" [:exercise]
                 "Rezepte" [:nutrition]
                 "Rezept" [:nutrition]
                 "Ausgewogene Ernährung" [:nutrition]
                 "Ernährung" [:nutrition]
                 "Gesundheit" [:healthy-living]
                 "Entspannung" [:relaxation]
                 :other)))))

(rf/reg-sub ::article-by-id
  :<- [:get [:articles]]

  (fn [articles [_ id]]
    (articles id)))

(rf/reg-sub ::articles-sorted
  :<- [:get [:articles]]

  (fn [articles _]
    (->> articles
         vals
         (map #(select-keys % [:id :tags :created-at]))
         (sort-by :created-at)
         reverse)))

(rf/reg-sub ::articles-id-panel
  :<- [::articles-sorted]

  (fn [articles _]
    (for [article articles]
      {:id (:id article) :panel (tags->panel (:tags article))})))

(rf/reg-sub ::active-filter-panels
  :<- [::effective-filter :categories]

  (fn [categories _]
    (flatten (distinct
              (for [category categories]
                (statics/category->topic category))))))

(rf/reg-sub ::articles-active
  :<- [::articles-id-panel]
  :<- [::active-filter-panels]

  (fn [[articles panels] _]
    (let [filtered-articles (filter #(not-empty (set/intersection
                                                 (set (:panel %))
                                                 (set panels)))
                                    articles)]
      (if (empty? filtered-articles)
        articles
        filtered-articles))))

(rf/reg-sub ::articles-id
  :<- [::articles-active]

  (fn [articles _]
    (map :id articles)))

                                        ; Products

;; The product source for the rendered list. Only the client-side branch derefs
;; `::products/data`, and a reaction subscribes to what it runs — which is what
;; keeps the catalogue fetch and its cache read off the server-only path.
(rf/reg-sub-raw ::catalogue-products
  (fn [_ _]
    (reaction
     (if @(rf/subscribe [::search/server-only?])
       (let [search @(rf/subscribe [::search/data])]
         {:status (if (:server-products search) :done (:status search))
          :products (or (:server-products search) {})})
       @(rf/subscribe [::products/data])))))

(rf/reg-sub ::product-by-id
  :<- [::catalogue-products]
  :<- [:get [:user :favorites]]

  (fn [[{:keys [status products]} favorites] [_ id]]
    (when (= status :done)
      (let [product (get products id)]
        (some-> product
                (assoc :favorite? (contains? favorites (:id product))))))))

(rf/reg-sub ::product-for-card
  (fn [[_ id]]
    [(rf/subscribe [::effective-filter :distance])
     (rf/subscribe [::product-by-id id])])
  (fn [[effective-filter-distance raw-product] _]
    (if (:site-addresses raw-product)
      (let [filter-distance (* 1000 effective-filter-distance)
            site-addresses-within-distance
            (filter #(< (:distance %) filter-distance)
                    (:site-addresses raw-product))]
        (-> raw-product
            (assoc :site-addresses-within-distance site-addresses-within-distance)
            (assoc :site-addresses-within-distance-count (count site-addresses-within-distance))))
      raw-product)))

(defn- remove-old-dates [children]
  (filterv #(time/after?
             (time/local-date-time (:registration-deadline %))
             (time/time-now))
           children))

(rf/reg-sub ::current-dates-for-product
  (fn [[_ id]]
    (rf/subscribe [::product-by-id id]))
  (fn [product _]
    (remove-old-dates (:children product))))

(rf/reg-sub ::next-datetime-for-product
  (fn [[_ id]]
    (rf/subscribe [::current-dates-for-product id]))
  (fn [dates]
    (apply min (map #(time/local-date-time (:when %)) dates))))

;; Callers must gate rendering on ::products-loaded?. The pending/stale branch
;; (`:else false`) returns no matches by design, relying on the loading state to
;; suppress an empty-list flash. A `:failed` result (a server error, or a response
;; without products) shows all products so the catalogue is never left empty on
;; transient failures. Only the client-side path reads this; on the server-only path
;; a failure raises the app error instead (`search/fail-fx`).
(defn matches-keyword-filter-with-server? [search-string server-result product]
  (cond
    (str/blank? search-string)
    true

    (and server-result
         (= search-string (:term server-result))
         (= (:status server-result) :done))
    (contains? (:ids server-result) (:id product))

    (and server-result
         (= search-string (:term server-result))
         (= (:status server-result) :failed))
    true

    :else
    false))

(defn matches-category-filter? [categories product]
  (or (empty? categories)
      (contains? categories (:category product))))

(defn matches-label-filter? [labels product]
  (or (empty? labels)
      (seq (set/intersection labels (:labels product)))))

(defn matches-type-filter? [product-types product]
  (or (empty? product-types)
      (contains? product-types (:type product))))

(defn matches-area-filter? [area product]
  (case area
    :all true
    :machtfit (= :machtfit (:area product))
    :company (= :company (:area product))
    true))

(defn matches-attribute-filter? [subsidy streams estg3no34-subsidizable? free-of-charge? apps? mf-offer price-min price-max product]
  (let [price-key :list-price]
    (and
     (or (not subsidy)
         (> (-> product :price :subsidy-by-employer) 0))
     (or (not streams)
         (:is-stream? product))
     (or (not price-min)
         (>= (-> product :price price-key) price-min))
     (or (not price-max)
         (<= (-> product :price price-key) price-max))
     (or (not estg3no34-subsidizable?)
         (:estg3no34-subsidizable? product))
     (or (not free-of-charge?)
         (zero? (-> product :price price-key)))
     (or (not apps?)
         (:is-app? product))
     (or (not mf-offer)
         (some? (-> product :price :suggested-retail-price))))))

(defn matches-promotion-filter? [promotions product]
  (or (not promotions)
      (:promotion? product)))

(defn matches-favorite-filter? [filter-favorites? product]
  (or (not filter-favorites?)
      (:favorite? product)))

(defn inst->time-string [inst]
  (gstring/format "%02d:%02d" (.getHours inst) (.getMinutes inst)))

(defn map->time-string [{:keys [hour minute]}]
  (gstring/format "%02d:%02d" hour minute))

(defn time-string-before? [time-str1 time-str2]
  (<= (compare time-str1 time-str2) 0))

(defn time-string-after? [time-str1 time-str2]
  (>= (compare time-str1 time-str2) 0))

(defn inst-matches-weekday-filter? [weekday-inst weekday-filter starts-after starts-before]
  (let [weekday-integer (datetime/inst->iso-weekday weekday-inst)
        time-str (inst->time-string weekday-inst)]
    (and (get weekday-filter weekday-integer)
         (or (not starts-after)
             (time-string-after? time-str starts-after))
         (or (not starts-before)
             (time-string-before? time-str starts-before)))))

(defn product-or-child-matches-weekday-filter? [product weekday-filter starts-after starts-before]
  (if (seq (:children product))
    (some #(product-or-child-matches-weekday-filter? % weekday-filter starts-after starts-before) (:children product))
    (if-let [appointments (:appointments product)]
      (every? #(inst-matches-weekday-filter? % weekday-filter starts-after starts-before) appointments)
      ; Products are declared to have a schedule {:has-schedule? true}
      ; but do not have any date/time information
      (if (:when product)
        (inst-matches-weekday-filter? (:when product) weekday-filter starts-after starts-before)
        true))))

(defn- weekday-and-times-match? [weekday-filter starts-after starts-before [weekday-int times]]
  (when (weekday-filter weekday-int)
    (some (fn [time]
            (let [time-str (map->time-string time)]
              (and (or (not starts-after)
                       (time-string-after? time-str starts-after))
                   (or (not starts-before)
                       (time-string-before? time-str starts-before)))))
          times)))

(defn product-with-weekdays-matches-weekday-filter? [product-weekdays weekday-filter starts-after starts-before]
  (some (partial weekday-and-times-match? weekday-filter starts-after starts-before) product-weekdays))

(defn matches-weekday-filter? [weekday-filter starts-after starts-before {:keys [has-schedule? weekdays] :as product}]
  (or (empty? weekday-filter)
      (not has-schedule?)
      (if (seq weekdays)
        (product-with-weekdays-matches-weekday-filter? weekdays weekday-filter starts-after starts-before)
        (product-or-child-matches-weekday-filter? product weekday-filter starts-after starts-before))))

(defn matches-distance-filter? [show-products-without-fixed-location? effective-filter-distance product]
  (or (not (some? effective-filter-distance))
      (let [filter-distance (* 1000 effective-filter-distance)]
        (cond
          (= (:area product) :company) true
          (= (:location-type product) :multiple)
          (seq (filter #(< (:distance %) filter-distance) (:site-addresses product)))

          (= (:location-type product) :fixed)
          (< (:distance product) filter-distance)

          :else show-products-without-fixed-location?))))

(rf/reg-sub-raw ::count-products-not-fixed
  (fn [_ _]
    (reaction
     (if @(rf/subscribe [::search/server-only?])
       (or (:online-count @(rf/subscribe [::search-facets/data])) 0)
       (let [{:keys [status products]} @(rf/subscribe [::products/data])]
         (if (= status :done)
           (->> products
                vals
                (map :location-type)
                (filter #(not= % :fixed))
                count)
           0))))))

(rf/reg-sub ::count-products-after-filter
  :<- [::filtered-products]

  (fn [products _]
    (count products)))

;; The cap the endpoint cut the result at, or nil when the count is exact.
;;
;; Callers mark their own count with it rather than showing it in place of one.
;; The cap is carried rather than a flag because it is the only number that
;; states how far the result was cut -- the rows are fewer, since hydration
;; drops ids it finds no longer visible. Client-side the client filters the whole
;; catalogue, so its count is exact and this stays nil.
(defn result-count-bound [server-only? search]
  (when server-only? (:truncated-at search)))

(rf/reg-sub ::result-count-bound
  :<- [::search/data]
  :<- [::search/server-only?]

  (fn [[search server-only?] _]
    (result-count-bound server-only? search)))

;; The exact match total the endpoint counted when the cap cut a browse it could
;; count cheaply, or nil. The catalogue counter shows it in place of the bound;
;; a nil (an uncut result, or a keyword search the cluster served or a subsidy
;; filter narrowed) leaves the bound. A term-less browse always counts: it ranks
;; its whole catalogue, so the total is the length of the ranked list even when
;; the subsidy filter decided it.
(defn result-count-total [server-only? search]
  (when server-only? (:total-count search)))

(rf/reg-sub ::result-count-total
  :<- [::search/data]
  :<- [::search/server-only?]

  (fn [[search server-only?] _]
    (result-count-total server-only? search)))

(rf/reg-sub ::has-products-after-filter?
  :<- [::count-products-after-filter]

  (fn [cnt _]
    (pos? cnt)))

(rf/reg-sub ::effective-sort-by
  :<- [::effective-filter :sort-by]

  (fn [filter-sort-by _]
    (get search/sort-modes filter-sort-by :recommended)))

(defn- filter-products [{:keys [status products]}
                        {:keys [categories
                                labels
                                product-types
                                area
                                subsidy streams estg3no34-subsidizable? free-of-charge? apps? mf-offer price-min price-max
                                promotions
                                favorites
                                online distance
                                weekdays starts-after starts-before]
                         keywords :keyword}
                        server-search]
  (when (= status :done)
    (->> products
         vals
         (filter (partial matches-keyword-filter-with-server? keywords server-search))
         (filter (partial matches-category-filter? categories))
         (filter (partial matches-label-filter? labels))
         (filter (partial matches-type-filter? product-types))
         (filter (partial matches-area-filter? area))
         (filter (partial matches-attribute-filter? subsidy streams estg3no34-subsidizable? free-of-charge? apps? mf-offer price-min price-max))
         (filter (partial matches-promotion-filter? promotions))
         (filter (partial matches-favorite-filter? favorites))
         (filter (partial matches-distance-filter? online distance))
         (filter (partial matches-weekday-filter? weekdays starts-after starts-before)))))

(rf/reg-sub ::annotated-products
  :<- [::catalogue-products]
  :<- [:get [:user :favorites]]
  :<- [::offer-layers/data]
  (fn [[{:keys [products] :as data} favorites-ids offer-layers-result] _]
    (let [layers (get offer-layers-result :offer-layers)
          by-id (fn [coll] (into {} (map (juxt :id :slug) coll)))
          delivery-type-slugs (by-id (get layers :delivery-types))
          service-format-slugs (by-id (get layers :service-formats))
          channel-slugs (by-id (get layers :channels))
          access-format-slugs (by-id (get layers :access-formats))
          health-category-slugs (by-id (get layers :health-categories))]
      (assoc data :products
             (into {} (map (fn [[id product]]
                             (let [{:keys [provider-id]} product
                                   provider-info (when provider-id
                                                   (first (filter (comp #{provider-id} :id) @(rf/subscribe [:get [:user :current-providers-for-user]]))))]
                               [id (-> product
                                       (assoc :is-subsidized? (> (get-in product [:price :subsidy-by-employer] 0) 0))
                                       (assoc :wellhub-product? (= (:name provider-info) "Wellhub"))
                                       (assoc :favorite? (contains? favorites-ids id))
                                       (assoc :delivery-type-slug (get delivery-type-slugs (:delivery-type-id product)))
                                       (assoc :service-format-slug (get service-format-slugs (:service-format-id product)))
                                       (assoc :channel-slugs (into #{} (keep channel-slugs (:channel-ids product))))
                                       (assoc :access-format-slug (get access-format-slugs (:access-format-id product)))
                                       (assoc :health-category-ids (set (:health-category-ids product)))
                                       (assoc :health-category-slugs (into #{} (keep health-category-slugs (:health-category-ids product)))))]))
                           products))))))

(rf/reg-sub ::filtered-products
  :<- [::annotated-products]
  :<- [::effective-filter]
  :<- [::search/data]
  :<- [::search/server-only?]

  (fn [[products-data effective-filter server-search server-only?]]
    (if server-only?
      (when (= (:status products-data) :done)
        (vals (:products products-data)))
      (filter-products products-data effective-filter server-search))))

(defn promote-nearby-site-addresses-to-products [{:keys [site-addresses] :as product} distance]
  (keep
   (fn [site-address]
     (when (< (:distance site-address) (* 1000 distance))
       (-> product
           (assoc :address site-address)
           (dissoc :site-addresses)
           (assoc :raw-product-id (:id product))
           (assoc :id (str (:id product) "-" (hash (str site-address)))))))
   site-addresses))

(rf/reg-sub ::products-for-map
  :<- [::filtered-products]
  :<- [::effective-filter]
  (fn [[products {:keys [distance]}] _]
    (concat
     (filter (comp :coords :address) products)
     (mapcat
      (fn [{:keys [site-addresses] :as product}]
        (when site-addresses
          (promote-nearby-site-addresses-to-products product distance)))
      products))))

(rf/reg-sub ::products-by-coordinates
  :<- [::products-for-map]
  (fn [products-for-map _]
    (group-by (comp :coords :address)
              products-for-map)))

(rf/reg-sub ::products-at-coordinates
  :<- [::products-by-coordinates]
  (fn [products-by-coordinates [_ coords]]
    (get products-by-coordinates coords)))

(rf/reg-sub ::product-coordinates-for-map
  :<- [::products-by-coordinates]
  (fn [products-by-coordinates _]
    (keys products-by-coordinates)))

(rf/reg-sub ::count-products-for-map
  :<- [::products-for-map]
  (fn [products _]
    (count products)))

(rf/reg-sub ::has-products-for-map?
  :<- [::count-products-for-map]
  (fn [cnt _]
    (> cnt 0)))

(rf/reg-sub ::show-map?
  :<- [:get [:map-toggle?]]
  :<- [:get [:user :machtfit-area-only-online?]]
  (fn [[map-toggle? only-online?]]
    (and map-toggle? (not only-online?))))

(defn first-non-empty-alternate-product-type
  "The product type the empty state offers instead. Counts arrive keywordized
  (cljs-ajax `:keywords? true`) while the filter values are strings."
  [product-type-counts]
  (some (fn [product-type]
          (when (pos? (get product-type-counts (keyword product-type) 0))
            product-type))
        ["online" "product" "with-location"]))

(rf/reg-sub-raw ::first-non-empty-alternate-product-type-filter
  (fn [_ _]
    (reaction
     (if @(rf/subscribe [::search/server-only?])
       (let [search @(rf/subscribe [::search/data])]
         ;; The in-flight merge keeps the previous response's counts, which
         ;; describe the previous filter.
         (when (= :done (:status search))
           (first-non-empty-alternate-product-type (:product-type-counts search))))
       (let [products-data @(rf/subscribe [::products/data])
             effective-filter @(rf/subscribe [::effective-filter])
             server-search @(rf/subscribe [::search/data])]
         (some
          (fn [alternate-product-type]
            (when (seq (filter-products
                        products-data
                        (assoc effective-filter :product-types #{alternate-product-type})
                        server-search))
              alternate-product-type))
          ["online", "product", "with-location"]))))))

(rf/reg-sub ::health-profile-goals
  :<- [::health-profile/data]
  (fn [{:keys [health-profile]} _]
    (into [] (keep (comp :de :answer)) (:goals health-profile))))

(defn health-goal-match-count [goals product]
  (reduce (fn [n goal]
            (if (contains? (:labels product) goal)
              (inc n)
              n))
          0
          goals))

(defn health-goal-match
  "nil until the profile has loaded and for a member without goals, so `false`
  means only \"has goals, none on this offer\". A failed fetch never stores the
  profile and so stays nil."
  [profile-status goals product]
  (when (and (= profile-status :done) (seq goals))
    (pos? (health-goal-match-count goals product))))

;; Gates the card's goal-match attribute. Read at the call site before
;; `::health-goal-match?` is subscribed, so with the flag off the startpage
;; neither sends the attribute nor fetches the health profile for it.
(rf/reg-sub ::health-goal-sort?
  :<- [::feature/feature-flag-enabled? :dev_3200_has_sort_by_health_goals_enabled]
  identity)

;; Read by the card's PostHog autocapture attribute, so a click records whether
;; the offer matched a goal whichever path ordered the grid.
(rf/reg-sub ::health-goal-match?
  (fn [[_ id]]
    [(rf/subscribe [::health-profile/data])
     (rf/subscribe [::health-profile-goals])
     (rf/subscribe [::product-by-id id])])
  (fn [[{:keys [status]} goals product] _]
    (health-goal-match status goals product)))

(rf/reg-sub ::sortable-products
  :<- [::filtered-products]
  :<- [::health-profile-goals]

  (fn [[products health-profile-goals] _]
    (let [price-key :list-price]
      (mapv (fn [product]
              (-> product
                  (update :price price-key)
                  (assoc :health-goal-match-count
                         (health-goal-match-count health-profile-goals product))))
            products))))

;; Search-result ranking lifts, expressed as "ranks more relevant" — a bounded
;; offset applied to the server relevance position so a promoted or subsidized
;; offer ranks higher among comparable matches without leapfrogging a clearly
;; better one. Wellhub is handled separately as a strict top tier. Tunable;
;; validated at the go/no-go re-test.
;;
;; These are interim M1 client knobs: commercial ranking lives here as
;; hand-tuned numbers so the rollout isn't blocked on the server. Every retune
;; is a CLJS deploy until M2 folds relevance + commercial scoring into the
;; server `SearchRank`. (Browse keeps its own boolean subsidy/promoted tiers —
;; see the non-server branch below — so the per-customer subsidy top-placement
;; on browse is intentionally preserved.)
(def ^:private promoted-search-rank-boost 25)
(def ^:private subsidized-search-rank-boost 15)

(defn- client-sorted-ids
  "Membership and order decided in the browser: the client-side path."
  [current-area products effective-sort-by sort-by-health-goals? search]
  ;; With a keyword and a stored server result the "recommended" order is
  ;; relevance-driven: Wellhub stays a strict top tier, while promoted and
  ;; subsidized offers fold into the relevance position as bounded "ranks more
  ;; relevant" lifts, so a clearly better match can still outrank them. Without
  ;; one, the original browse heuristic is unchanged.
  (let [rank-by-id (when (and (= (:status search) :done)
                              (not (str/blank? (:term search))))
                     (:rank-by-id search))
        health-goal-key (when sort-by-health-goals?
                          [(comp - :health-goal-match-count)])
        ;; Tail shared by both "recommended" orderings: once the head has
        ;; ordered comparable matches, both fall back through these keys.
        recommended-tail (concat health-goal-key
                                 [:sorting-number
                                  (complement :reco-engine-recommended?)
                                  :price
                                  :distance
                                  :title])
        effective-relevance
        (fn [product]
        ;; Fold the commercial lifts into the server relevance position as a
        ;; single bounded "ranks more relevant" offset — the strongest
        ;; applicable boost, not the sum of both. The offset moves an offer
        ;; up by at most `lift` positions and preserves the relative order
        ;; of the boosted offers, so a clearly better match still outranks
        ;; them. A negative result is fine for sorting; it just places the
        ;; offer ahead of the top rank. (Clamping at 0 was wrong: it
        ;; collapsed every boosted offer in the top `lift` ranks into a
        ;; single 0-tie, pinning weak commercial matches above genuine top
        ;; matches.)
          (let [lift (max (if (:promoted? product) promoted-search-rank-boost 0)
                          (if (:is-subsidized? product) subsidized-search-rank-boost 0))]
            (- (get rank-by-id (:id product) js/Infinity) lift)))
        recommended-key
        (if rank-by-id
          (apply juxt
                 (concat [(complement :wellhub-product?)
                          effective-relevance]
                         recommended-tail))
          (apply juxt
                 (concat [(complement :wellhub-product?)
                          (complement :is-subsidized?)
                          (complement :promoted?)]
                         recommended-tail)))
        sort-key (case effective-sort-by
                   :price-asc (juxt :price (complement :promoted?) :sorting-number :distance :title)
                   :price-desc (juxt (comp - :price) (complement :promoted?) :sorting-number :distance :title)
                   :distance (juxt :distance (complement :promoted?) :sorting-number :price :title)
                   :recommended recommended-key
                   :date-published (juxt (comp - :date-published) (complement :promoted?) :sorting-number :price :title))
        sorted-products (sort-by sort-key products)
        sorted-products (cond
                          (= effective-sort-by :distance)
                          (let [{products-fixed true
                                 products-not-fixed false} (group-by #(= (:location-type %) :fixed) sorted-products)
                                products-fixed-count (-> products-fixed
                                                         count
                                                         inc)
                                products-not-fixed-count (-> products-not-fixed
                                                             count
                                                             inc)
                                ratio-fixed (-> products-fixed-count
                                                (/ products-not-fixed-count)
                                                Math/ceil)
                                ratio-not-fixed (-> products-not-fixed-count
                                                    (/ products-fixed-count)
                                                    Math/ceil)]
                            (flatten (interleave-all (partition-all ratio-fixed products-fixed)
                                                     (partition-all ratio-not-fixed products-not-fixed))))

                          (and (= current-area :all) (= effective-sort-by :recommended))
                          (let [{machtfit-area true
                                 company-area false} (group-by #(= (:area %) :machtfit) sorted-products)
                                machtfit-products-ratio 10
                                company-products-ratio 1]
                            (flatten (interleave-all (partition-all machtfit-products-ratio machtfit-area)
                                                     (partition-all company-products-ratio company-area))))

                          :else
                          sorted-products)]
    (map :id sorted-products)))

(rf/reg-sub-raw ::products-sorted-ids
  (fn [_ _]
    (reaction
     (let [search @(rf/subscribe [::search/data])]
       (if @(rf/subscribe [::search/server-only?])
         (:order search)
         ;; Derefed only here, so the server-only render does not build and
         ;; discard the whole client sort pipeline.
         (client-sorted-ids
          @(rf/subscribe [::effective-filter :area])
          @(rf/subscribe [::sortable-products])
          @(rf/subscribe [::effective-sort-by])
          @(rf/subscribe [::feature/feature-flag-enabled?
                          :dev_3200_has_sort_by_health_goals_enabled])
          search))))))

(rf/reg-sub ::products-sorted
  :<- [::products-sorted-ids]
  :<- [::products-loaded?]

  (fn [[products products-loaded?] _]
    (let [products (if products-loaded?
                     (for [id products]
                       {:id id :type :product})
                     (repeat 31 {:type :placeholder}))]
      products)))

;; Drives the "no exact matches" notice: the server fell back to a relaxed
;; (OR-of-tokens) match and offers remain after filters (so it never shows
;; above an empty grid).
(rf/reg-sub ::relaxed-search?
  :<- [::search/data]
  :<- [::has-products-after-filter?]

  (fn [[search has-products?] _]
    (and (= (:status search) :done)
         (true? (:relaxed? search))
         has-products?)))

;; Which engine produced the current keyword-search results, for tracking.
;; Derived from the settled server response, so it distinguishes an exact match
;; from the relaxed (OR-of-tokens) fallback, and names the engine the server says
;; answered rather than assuming Postgres — a search served by OpenSearch, or one
;; that fell back mid-flight, is reported as what it was. The server spells its
;; engine with an underscore, matching its metric label; the dashes here are the
;; established event value, so the name is translated rather than either side
;; renamed. nil while a search is pending, has failed, or when no keyword is set.
(rf/reg-sub ::search-engine
  :<- [::search/data]
  :<- [::search/server-only?]

  (fn [[search server-only?] _]
    (when (= :done (:status search))
      (cond
        (not (str/blank? (:term search)))
        (str (str/replace (or (:engine search) "postgres_fts") "_" "-")
             (if (:relaxed? search) "-relaxed" "-exact")
             (when server-only? "-server-only"))

        ;; A term-less browse asks no engine anything, so it names none.
        server-only?
        "browse-server-only"))))

(rf/reg-sub ::distance-histogram
  :<- [::products/data]

  (fn [{:keys [status products]} _]
    (if (= status :done)
      (->> products
           vals
           (map #(:distance %))
           (remove nil?)
           (map #(-> % (/ 1000) int (+ 1)))
           frequencies)
      {})))

;; Only the buckets an offer falls into matter here, so the server-only path reads
;; the server's bucket list rather than a histogram it has no counts for.
(rf/reg-sub-raw ::offer-distance-buckets
  (fn [_ _]
    (reaction
     (if @(rf/subscribe [::search/server-only?])
       (:distance-buckets @(rf/subscribe [::search-facets/data]))
       (keys @(rf/subscribe [::distance-histogram]))))))

(rf/reg-sub ::next-offer-distance
  :<- [::offer-distance-buckets]
  :<- [::effective-filter :distance]

  (fn [[buckets current-distance] _]
    ;; Nil, not an arity error, when no bucket lies beyond the current radius --
    ;; the common case at the 70km default. `cljs.core/min` declares no 0-arity,
    ;; so its variadic one absorbs the call and yields `js/undefined`, which CLJS
    ;; `nil?` accepts. The consumer's `some?` check then hides the widen-the-radius
    ;; button, which is the intent.
    (apply min (remove #(<= % current-distance) buckets))))

(rf/reg-sub ::products-loaded?
  :<- [::catalogue-products]
  :<- [::search/data]
  :<- [::effective-filter :keyword]
  :<- [::search/server-only?]

  (fn [[products-data search raw-keyword server-only?] _]
    (if server-only?
      ;; A settled request counts as loaded even when it failed, or a first
      ;; failure would leave the grid on placeholders for good. In-flight
      ;; refetches preserve `:order`, so they keep the last results on screen.
      (or (#{:done :failed} (:status search)) (some? (:order search)))
      (let [effective-keyword (or raw-keyword "")
            settled-for-keyword? (and (= effective-keyword (:term search))
                                      (#{:done :failed} (:status search)))
            search-loading? (and (not (str/blank? effective-keyword))
                                 (not settled-for-keyword?))]
        (and (= (:status products-data) :done)
             (not search-loading?))))))

(rf/reg-sub ::startpage-data-loaded?
  (fn [db _]
    (api-events/startpage-data-loaded? db)))

(rf/reg-sub ::show-error?
  (fn [db _]
    (and (db :error?)
               ;; Don't show error when app is unloading
               ;; https://machtfit.atlassian.net/browse/MAC-2585
         (not (db :unloading?)))))

(rf/reg-sub ::first-notification
  :<- [:get [:user :notifications]]

  (fn [notifications _]
    (when (some? notifications) (first notifications))))

(rf/reg-sub ::filter-set?
  :<- [::effective-filter]

  (fn [current-filter _]
    (not= filter/default-filter (dissoc current-filter :sort-by))))

(rf/reg-sub ::slider-items?
  :<- [:get [:slider :items]]

  (fn [slider-items _]
    (seq slider-items)))

(rf/reg-sub ::non-empty-categories
  (fn [db _]
    (filter/db->non-empty-categories db)))

(rf/reg-sub ::non-empty-categories-in-current-area
  :<- [::non-empty-categories]
  :<- [::effective-filter :area]

  (fn [[{:keys [machtfit company]} area] _]
    (set (case area
           :machtfit machtfit
           :company company
           (concat machtfit company)))))

(rf/reg-sub ::effective-filter
  :<- [:get [:filter]]
  :<- [:get [:ui :filter-preset]]
  :<- [:get [:user :labels]]
  :<- [::non-empty-categories]

  (fn [[filter filter-preset user-labels non-empty-categories] [_ which]]
    (let [effective-filter (filter/effective-filter filter-preset filter non-empty-categories user-labels)]
      (if which
        (get effective-filter which)
        effective-filter))))

;; The search status, not ``::catalogue-products``: that wrapper reports ``:done``
;; for as long as any previous response is on screen, and the server-only refetch
;; deliberately leaves the old grid rendered while the new request is in flight.
(defn products-settled? [server-only? search-status products]
  (if server-only?
    (= :done search-status)
    (boolean (seq products))))

(rf/reg-sub-raw ::filter-data-for-tracking
  (fn [_ _]
    (reaction
     (let [server-only? @(rf/subscribe [::search/server-only?])
           products (when-not server-only?
                      @(rf/subscribe [::products/data-without-fetching]))
           settled? (products-settled? server-only?
                                       (:status @(rf/subscribe [::search/data]))
                                       products)]
       {:location @(rf/subscribe [:get [:products-location]])
        :products-settled? settled?
        :products-count (when settled?
                          @(rf/subscribe [::count-products-after-filter]))
        :filter-preset @(rf/subscribe [:get [:ui :filter-preset]])
        :effective-filter @(rf/subscribe [::effective-filter])
        :search-engine @(rf/subscribe [::search-engine])
        :page-id @(rf/subscribe [:get [:ui :page :id]])}))))

(rf/reg-sub ::show-marketplace?
  :<- [:get [:user :has-machtfit-area?]]
  :<- [:get [:area-independent-products-available?]]
  (fn [[has-machtfit-area? area-independent-products-available?]]
    (or has-machtfit-area?
        area-independent-products-available?)))
